import { RouteConfig } from 'vue-router';
const ReportingModule = () =>
  import(/* webpackChunkName: 'reporting' */ './ReportingModule.vue');
const ReportingPage = () =>
  import(/* webpackChunkName: 'reporting' */ './pages/ReportingPage.vue');
const GenerateReport = () =>
  import(/* webpackChunkName: 'reporting' */ './pages/GenerateReport.vue');
import { TARGET_ENTITIES } from '@/utils/constants';

export const ReportingRoutes: RouteConfig[] = [
  {
    path: '',
    component: ReportingModule,
    name: 'reporting',
    props: true,
    meta: {
      middlewares: {
        canAccessEntity: TARGET_ENTITIES.reports
      }
    },
    children: [
      {
        path: 'reporting',
        meta: {
          title: 'Reporting'
        },
        name: 'reportingPage',
        component: ReportingPage
      },
      {
        path: '/generate',
        meta: {
          title: 'Reporting'
        },
        name: 'generatePage',
        component: GenerateReport
      }
    ]
  }
];
